/**
 * utils/accountType.ts
 * Account type validation and categorization utilities
 *
 * Provides helper functions for validating account types and determining
 * account type categories for business logic and broker filtering.
 */

// Internal absolute imports
import type { AccountType } from '@/types/shared/AccountType';

/**
 * Type guard to check if a value is a valid AccountType
 */
export function isValidAccountType(value: unknown): value is AccountType {
  return typeof value === 'string' && [
    'personal', 'prop', 'paper', 'retirement',
    'business', 'trust', 'pooled', 'other'
  ].includes(value);
}

/**
 * Check if account type should be treated like personal for broker filtering
 */
export function isPersonalLikeAccountType(accountType: AccountType): boolean {
  return ['personal', 'retirement', 'business', 'trust', 'pooled', 'other'].includes(accountType);
}
